import { ValidationErrors } from '@angular/forms';

export function getErrorMessage(errors: ValidationErrors | null, label: string): string {
  if (!errors) return '';

  if (errors['customMessage']) return errors['customMessage'];
  if (errors['required']) return `${label} is required`;
  if (errors['email']) return `Please enter a valid email for ${label}`;
  if (errors['minlength'])
    return `Minimum ${errors['minlength'].requiredLength} characters required`;
  if (errors['maxlength'])
    return `Maximum ${errors['maxlength'].requiredLength} characters allowed`;
  if (errors['min'])
    return `Minimum value is ${errors['min'].min}`;
  if (errors['max'])
    return `Maximum value is ${errors['max'].max}`;

  return 'Invalid value';
}